export enum FormInitializationType {
	EMPTY,
	LOCAL_STORAGE,
	DATABASE,
}
